import React, { useEffect, useState } from 'react';
import './HseApp.scss';
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import hseCoverImg from '../../assets/images/hse__cover.png';
import hseCollageImg from '../../assets/images/hse__collage.png';
import hseMobileAndLapImg from '../../assets/images/hse__mobile-and-laptop.png';
import hseJobStoriesImg from '../../assets/images/hse__job-stories.png';
import hseJobStoriesMobImg from '../../assets/images/hse__job-stories_mob.png';
import hseCompetitionsImg from '../../assets/images/hse__competitions.png';
import hseCompetitionsMob1Img from '../../assets/images/hse__competitions_mob1.png';
import hseCompetitionsMob2Img from '../../assets/images/hse__competitions_mob2.png';
import hseScriptImg from '../../assets/images/hse__script.png';
import hseIdeationImg from '../../assets/images/hse__ideation.png';
import hseDesignSystemImg from '../../assets/images/hse__design-system.png';
import hseDesignSystemMobImg from '../../assets/images/hse__design-system_mob.png';
import hseDeadlinesImg from '../../assets/images/hse__deadline-features.png';
import hseGridImg from '../../assets/images/hse__grid.png';
import hseNewTasksImg from '../../assets/images/hse__new-tasks.png';
import hseTaskViewImg from '../../assets/images/hse__task-view.png';
import FadeInSection from '../../components/FadeInSection';
import SkeletonPage from '../../components/SkeletonPage/SkeletonPage';


const HseApp = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    // Создаем объект Image для предварительной загрузки
    const img = new Image();
    img.src = hseCoverImg; // Укажите URL изображения

    // Устанавливаем слушатель загрузки для обновления состояния
    img.onload = () => {
      setIsImageLoaded(true);
    };

    // Обработка ошибки (если изображение не загружается)
    img.onerror = () => {
      console.error('Ошибка загрузки изображения');
      setIsImageLoaded(true); // Загрузить страницу, даже если изображение не загрузилось
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      {!isImageLoaded && (
        <SkeletonPage />
      )}
      {isImageLoaded && (
        <section className="hse case">
          <ProgressBar />
          <FadeInSection>
            <h1 className="case__title">
              HSE University is consistently ranked as one of Russia's top universities and is a
              leader in education. It is also considered{' '}
              <span className="case__title-span">
                {' '}
                one of the top economics and social sciences universities in Eastern Europe and
                Eurasia
              </span>
            </h1>
          </FadeInSection>
          <div className="case__content">
            <FadeInSection>
              <img className="case__content-image" src={hseCoverImg} alt="screen" />
            </FadeInSection>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">About</h3>
                  <p>
                    This is my graduation project for Practicum UX/UI design training course. It
                    involves <span>designing a new feature for the mobile application</span> HSE App
                    X, which is a mobile app for students of the Higher School of Economics
                  </p>{' '}
                </FadeInSection>
                <FadeInSection>
                  <h3 className="text-and-image__title">Problem</h3>
                  <div>
                    <p>
                      Based on the feedback from students, it was discovered that the current state
                      of homework management is disorganized as it is spread across various
                      services, causing students to have to recall information about assignments,
                      deadlines, and assessments for their current courses and subjects
                    </p>
                    <p>
                      This often leads to forgetfulness, which negatively impacts their performance
                      and motivation
                    </p>
                  </div>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={hseCollageImg} alt="collage" />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Purpose</h3>
                  <div>
                    <p>
                      The purpose of the work was to simplify the process of completing assignments
                      for students
                    </p>
                    <p>
                      To address this issue, it was decided to incorporate all information about
                      each subject, current assignments, and deadlines into the students' personal
                      accounts for better organization and management
                    </p>
                  </div>{' '}
                </FadeInSection>
              </div>
            </div>
            <FadeInSection>
              <h2 className="case__title streamy__title">
                <span className="case__title-span">Hypothesis:</span> Reflecting all assignments in
                a personal account, with reminders sent before the deadline,
                <span className="case__title-span">
                  will enable students to submit work on time, improving their academic performance
                </span>{' '}
                through better time management
              </h2>
            </FadeInSection>

            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={hseMobileAndLapImg}
                    alt="mobile phone"
                  />
                </FadeInSection>
              </div>
            </div>
            <FadeInSection>
              <h2 className="case__title streamy__title">
                I started my work with
                <br />a research that allowed me to determine the future feature logic and user
                needs
              </h2>{' '}
            </FadeInSection>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Interview</h3>
                  <p>
                    For a comprehensive survey of the target audience, I chose not only
                    representatives of the target audience but also other respondents: students and
                    graduates of HSE and other universities, with Bachelor's and Master’s degrees
                    and postgraduate education in Russia and abroad. To reach different segments of
                    the target audience in equal numbers I interviewed a total of 7 people
                  </p>
                </FadeInSection>
                <FadeInSection>
                  <h3 className="text-and-image__title">Job Stories</h3>
                  <div>
                    <p>
                      After the interviews, I created User Stories to work with specific user needs.
                      It helped me provide effective solutions based on the real experience of the
                      respondents
                    </p>
                  </div>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={screenWidth > 853 ? hseJobStoriesImg : hseJobStoriesMobImg}
                    alt="job stories"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Solution</h3>
                  <p>
                    Instead of using the HSE App X, students entered their entire schedule into
                    third-party calendars and task trackers. Therefore, it was decided to implement
                    a task tracker into the university application
                  </p>
                </FadeInSection>
                {screenWidth < 853 && (
                  <div className="text-and-image__image">
                    <FadeInSection>
                      <img
                        className="text-and-image__single-img"
                        src={hseCompetitionsMob1Img}
                        alt="job stories"
                      />
                    </FadeInSection>
                  </div>
                )}
                <FadeInSection>
                  <h3 className="text-and-image__title">Сompetitor research</h3>
                  <div>
                    <p>
                      The new function competes with email, calendars, task trackers, notes, and
                      even paper. Pros and cons of competitive products:
                    </p>
                  </div>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={screenWidth > 853 ? hseCompetitionsImg : hseCompetitionsMob2Img}
                    alt="Сompetitor research"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Custom Scripts</h3>
                  <p>
                    In the course of work, I created the main, additional and emergency custom
                    scripts for the new application function
                  </p>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={hseScriptImg}
                    alt="Custom script"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Ideation</h3>
                  <p>
                    The process of ideation is an essential part of creating and bringing ideas to
                    life. Using pencil and paper as your tools for ideation is a great way to get
                    started
                  </p>{' '}
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={hseIdeationImg} alt="Ideation" />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Wireframes</h3>
                  <p>
                    The next stage of work involves designing low-fidelity wireframes, which enables
                    to quickly design the future system
                  </p>{' '}
                </FadeInSection>
                <FadeInSection>
                  <h3 className="text-and-image__title">Design system</h3>
                  <div>
                    <p>I utilized the HSE University design system to design the user interface</p>
                  </div>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={screenWidth > 853 ? hseDesignSystemImg : hseDesignSystemMobImg}
                    alt="design system"
                  />
                </FadeInSection>
              </div>
            </div>
            <FadeInSection>
              <h2 className="case__title streamy__title">
                Based on the results obtained from the research, I was able to create an application
                that{' '}
                <span className="case__title-span">meets both requirements and user needs</span>
              </h2>
            </FadeInSection>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__image hse__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={hseDeadlinesImg}
                    alt="deadline features"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__image">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={hseGridImg} alt="grid" />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__image hse__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={hseNewTasksImg}
                    alt="New tasks"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__image hse__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={hseTaskViewImg}
                    alt="Task view"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Result</h3>
                  <div>
                    <p>
                      After conducting extensive testing on the target audience,{' '}
                      <span>
                        I was able to gain critical insights that allowed me to solve the problem
                        presented to me
                      </span>
                    </p>
                    <p>
                      By leveraging the latest technologies and best practices, I was able to create
                      a product that not only met but exceeded the needs of the users. By focusing
                      on every detail and carefully listening to feedback, I was able to create a
                      product that truly met the needs of all target audience involved
                    </p>
                  </div>{' '}
                </FadeInSection>
              </div>
            </div>
            <FadeInSection>
              <h2 className="case__title streamy__title">
                Overall, my approach to problem-solving is grounded in a deep understanding of both
                the user and the customer, which allows me to create solutions that are{' '}
                <span className="case__title-span">both effective and attractive</span>
              </h2>{' '}
            </FadeInSection>
          </div>
        </section>
      )}
    </>
  );
};

export default HseApp;
